/* Daymark alarm band PDP controller — vanilla JS, scoped to [data-dm-main] and .dm-pdp.
   Bridges the mockup UI to the theme's real <product-form> (product-form.js): the hidden name="id" input,
   the name="quantity" input and the form's submit button. Cart add + cart notification/drawer stay native. */
(function () {
  if (window.__dmPdpLoaded) return;
  window.__dmPdpLoaded = true;

  /* Accordions (all Daymark sections) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.dm-pdp .dm-acc__btn');
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = open;
  });

  function readJSON(root, sel, fallback) {
    var el = root.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (err) { return fallback; }
  }

  function initMain(root) {
    if (root.__dmInit) return;
    root.__dmInit = true;

    var variants = readJSON(root, '[data-dm-variants]', []);
    var colours = readJSON(root, '[data-dm-colours]', {});
    var strings = readJSON(root, '[data-dm-strings]', {});
    var form = root.querySelector('product-form form');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var qtyInput = root.querySelector('[data-dm-qty-input]');
    var atc = root.querySelector('[data-dm-atc]');
    var atcLabel = root.querySelector('[data-dm-atc-label]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-dm-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dm-thumb]'));
    var count = root.querySelector('[data-dm-count]');
    var stage = root.querySelector('[data-dm-stage]');
    var current = 0;

    function byId(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }
    var variant = byId(idInput && idInput.value) || variants[0];

    /* ---------- gallery ---------- */
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== current; });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === current ? 'true' : 'false'); });
      if (count) count.textContent = (current + 1) + ' / ' + slides.length;
    }
    root.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-dm-nav]');
      if (nav && root.contains(nav)) { show(current + Number(nav.getAttribute('data-dm-nav'))); return; }
      var th = e.target.closest('[data-dm-thumb]');
      if (th && root.contains(th)) { show(Number(th.getAttribute('data-dm-thumb'))); return; }
      var q = e.target.closest('[data-dm-qty]');
      if (q && root.contains(q)) { stepQty(Number(q.getAttribute('data-dm-qty'))); }
    });
    if (stage) {
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(current + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(current - 1); e.preventDefault(); }
      });
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    /* ---------- quantity (real name="quantity" input) ---------- */
    function syncQty() {
      var q = qtyInput ? qtyInput.value : '1';
      root.querySelectorAll('[data-dm-sticky-qty]').forEach(function (el) { el.textContent = q; });
    }
    function stepQty(dir) {
      if (!qtyInput) return;
      var step = Number(qtyInput.step) || 1;
      var min = Number(qtyInput.min) || 1;
      var max = qtyInput.max ? Number(qtyInput.max) : Infinity;
      var v = (Number(qtyInput.value) || min) + dir * step;
      qtyInput.value = Math.min(max, Math.max(min, v));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var min = Number(qtyInput.min) || 1;
        if (!(Number(qtyInput.value) >= min)) qtyInput.value = min;
        syncQty();
      });
      qtyInput.addEventListener('input', syncQty);
    }

    /* ---------- variant (real name="id" input) ---------- */
    function setText(sel, txt) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }
    function applyVariant(v, updateUrl) {
      if (!v) return;
      variant = v;
      if (idInput) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // live price / compare-at
      setText('[data-dm-price]', v.price);
      var cmp = root.querySelector('[data-dm-compare]');
      if (cmp) {
        cmp.hidden = !v.compare;
        if (v.compare) root.querySelector('[data-dm-compare-value]').textContent = v.compare;
      }
      setText('[data-dm-sticky-price]', v.price);
      setText('[data-dm-final-price]', v.price);
      // colour name
      setText('[data-dm-colorname]', v.option1);
      setText('[data-dm-sticky-color]', v.option1);
      setText('[data-dm-final-color]', v.option1);
      // quantity rules
      if (qtyInput) {
        qtyInput.min = v.min || 1;
        qtyInput.step = v.step || 1;
        if (v.max) qtyInput.max = v.max; else qtyInput.removeAttribute('max');
        if (Number(qtyInput.value) < qtyInput.min) qtyInput.value = qtyInput.min;
        syncQty();
      }
      // availability
      var label = v.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      if (atc) {
        if (v.available) { atc.removeAttribute('disabled'); atc.removeAttribute('aria-disabled'); }
        else atc.setAttribute('disabled', 'disabled');
      }
      if (atcLabel) atcLabel.textContent = label;
      document.querySelectorAll('[data-dm-atc-mirror]').forEach(function (b) {
        b.disabled = !v.available;
        if (!v.available) { b.dataset.dmLabel = b.dataset.dmLabel || b.textContent; b.textContent = strings.soldOut || 'Sold out'; }
        else if (b.dataset.dmLabel) { b.textContent = b.dataset.dmLabel; }
      });
      // media: map the real variant to its approved colour asset
      var c = colours[v.option1];
      if (c && c.src) {
        root.querySelectorAll('[data-dm-variant-img]').forEach(function (img) { img.src = c.src; img.alt = (c.alt || (v.option1 + ' ' + (img.getAttribute('data-dm-alt-suffix') || ''))).trim(); });
        root.querySelectorAll('[data-dm-variant-thumb],[data-dm-sticky-img]').forEach(function (img) { img.src = c.src; });
      }
      var vi = root.querySelector('[data-dm-variant-img]');
      if (vi) { var slide = vi.closest('[data-dm-slide]'); if (slide) show(Number(slide.getAttribute('data-dm-slide'))); }
      // URL, the way the theme does it
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (updateUrl && typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        window.publish(window.PUB_SUB_EVENTS.variantChange, { data: { sectionId: root.dataset.sectionId, html: null, variant: v } });
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-dm-variant-input]')) applyVariant(byId(e.target.value), true);
    });

    /* ---------- sticky + final CTA submit the one real product form ---------- */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dm-submit]');
      if (!b || b.disabled || !form) return;
      e.preventDefault();
      var submit = form.querySelector('[type="submit"]');
      if (form.requestSubmit) form.requestSubmit(submit || undefined);
      else if (submit) submit.click();
    });

    var sticky = root.querySelector('[data-dm-sticky]');
    var buyRow = root.querySelector('[data-dm-buyrow]');
    var ticking = false;
    function setSticky() {
      ticking = false;
      if (!sticky || !buyRow) return;
      var vh = window.innerHeight;
      var b = buyRow.getBoundingClientRect();
      var finalBtn = document.querySelector('.dm-pdp--final [data-dm-submit]');
      var f = finalBtn ? finalBtn.getBoundingClientRect() : null;
      var vis = b.bottom < 0 && !(f && f.top < vh && f.bottom > 0);
      sticky.setAttribute('data-visible', String(vis));
      if (vis) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(setSticky); } }, { passive: true });
    window.addEventListener('resize', setSticky);

    // initial state (respect ?variant=)
    var checked = root.querySelector('[data-dm-variant-input]:checked');
    if (checked && byId(checked.value)) applyVariant(byId(checked.value), false);
    show(0);
    syncQty();
    setSticky();
  }

  function boot() { document.querySelectorAll('[data-dm-main]').forEach(initMain); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { if (e.target) e.target.querySelectorAll('[data-dm-main]').forEach(initMain); });
})();
